const ADDRESS_FILTER_FORM_SELECTOR = "form[data-address-location-filter='true']";

function cloneOptions(select) {
  return Array.from(select.options).map((option) => option.cloneNode(true));
}

function findBlankOption(options, fallbackLabel) {
  const blank = options.find((option) => option.value === "");
  return blank ? blank.cloneNode(true) : new Option(fallbackLabel, "");
}

function replaceOptions(select, options, blankOption, selectedValue) {
  select.innerHTML = "";
  select.appendChild(blankOption.cloneNode(true));
  options.forEach((option) => select.appendChild(option.cloneNode(true)));

  const normalizedValue = String(selectedValue || "");
  const selectedExists = Array.from(select.options).some((option) => option.value === normalizedValue);
  select.value = selectedExists ? normalizedValue : "";
}

function setupAddressLocationFilter(form) {
  const countrySelect = form.querySelector("select[data-address-filter='country']");
  const stateSelect = form.querySelector("select[data-address-filter='state']");
  const citySelect = form.querySelector("select[data-address-filter='city']");

  if (!countrySelect || !stateSelect || !citySelect) {
    return;
  }

  const allStateOptions = cloneOptions(stateSelect);
  const allCityOptions = cloneOptions(citySelect);
  const stateBlankOption = findBlankOption(allStateOptions, "Selecione um estado");
  const cityBlankOption = findBlankOption(allCityOptions, "Selecione uma cidade");

  const filterStates = (countryId, stateIdToKeep = "") => {
    const filteredStates = allStateOptions.filter((option) => {
      return option.value !== "" && option.dataset.countryId === countryId;
    });

    replaceOptions(stateSelect, filteredStates, stateBlankOption, stateIdToKeep);
    stateSelect.disabled = countryId === "";
  };

  const filterCities = (stateId, cityIdToKeep = "") => {
    const filteredCities = allCityOptions.filter((option) => {
      return option.value !== "" && option.dataset.stateId === stateId;
    });

    replaceOptions(citySelect, filteredCities, cityBlankOption, cityIdToKeep);
    citySelect.disabled = stateId === "";
  };

  const initialStateId = stateSelect.value;
  const initialCityId = citySelect.value;

  filterStates(countrySelect.value, initialStateId);
  filterCities(stateSelect.value, initialCityId);

  countrySelect.addEventListener("change", () => {
    filterStates(countrySelect.value);
    filterCities("");
  });

  stateSelect.addEventListener("change", () => {
    filterCities(stateSelect.value);
  });
}

export function initAddressLocationFilter() {
  document.querySelectorAll(ADDRESS_FILTER_FORM_SELECTOR).forEach((form) => {
    setupAddressLocationFilter(form);
  });
}
